"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * SOLID Workflow Service
 * SOLID Workflow Service - API version 1
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowsApi = exports.WorkflowsApiFactory = exports.WorkflowsApiFp = exports.WorkflowsApiAxiosParamCreator = exports.TreatmentPlanRequestsApi = exports.TreatmentPlanRequestsApiFactory = exports.TreatmentPlanRequestsApiFp = exports.TreatmentPlanRequestsApiAxiosParamCreator = exports.TenantsApi = exports.TenantsApiFactory = exports.TenantsApiFp = exports.TenantsApiAxiosParamCreator = exports.RegionsApi = exports.RegionsApiFactory = exports.RegionsApiFp = exports.RegionsApiAxiosParamCreator = exports.PatientsApi = exports.PatientsApiFactory = exports.PatientsApiFp = exports.PatientsApiAxiosParamCreator = exports.MonitoringApi = exports.MonitoringApiFactory = exports.MonitoringApiFp = exports.MonitoringApiAxiosParamCreator = exports.ItemsApi = exports.ItemsApiFactory = exports.ItemsApiFp = exports.ItemsApiAxiosParamCreator = exports.DataExtractionApi = exports.DataExtractionApiFactory = exports.DataExtractionApiFp = exports.DataExtractionApiAxiosParamCreator = exports.WorkflowExecutionStatusEnum = exports.PostOperativeDataSpecialCircumstanceEnum = exports.PostOperativeDataFixationTypeEnum = exports.PatientSex = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * Enumeration of the supported values for the patient\'s sex.
 * @export
 * @enum {string}
 */
exports.PatientSex = {
    Female: 'female',
    Male: 'male',
    Other: 'other'
};
exports.PostOperativeDataFixationTypeEnum = {
    Cemented: 'cemented',
    Cementless: 'cementless'
};
exports.PostOperativeDataSpecialCircumstanceEnum = {
    Emergency: 'emergency',
    VisitorPresent: 'visitorPresent',
    LogisticOrEquipmentIssue: 'logisticOrEquipmentIssue',
    BilateralCase: 'bilateralCase',
    Other: 'other'
};
exports.WorkflowExecutionStatusEnum = {
    NotStarted: 'notStarted',
    InProgress: 'inProgress',
    Error: 'error',
    Completed: 'completed'
};
/**
 * DataExtractionApi - axios parameter creator
 * @export
 */
exports.DataExtractionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Starts the extraction of the data of all unextracted treatment plan requests.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataExtractionPost: function (tenantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('dataExtractionPost', 'tenantId', tenantId);
                            localVarPath = "/data-extraction";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes the extraction status of of the treatment plan request so that it will be considered for extraction again.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataExtractionTreatmentPlanRequestsIdDelete: function (id, tenantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('dataExtractionTreatmentPlanRequestsIdDelete', 'id', id);
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('dataExtractionTreatmentPlanRequestsIdDelete', 'tenantId', tenantId);
                            localVarPath = "/data-extraction/treatment-plan-requests/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * DataExtractionApi - functional programming interface
 * @export
 */
exports.DataExtractionApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.DataExtractionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Starts the extraction of the data of all unextracted treatment plan requests.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataExtractionPost: function (tenantId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dataExtractionPost(tenantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes the extraction status of of the treatment plan request so that it will be considered for extraction again.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataExtractionTreatmentPlanRequestsIdDelete: function (id, tenantId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dataExtractionTreatmentPlanRequestsIdDelete(id, tenantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * DataExtractionApi - factory interface
 * @export
 */
exports.DataExtractionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.DataExtractionApiFp(configuration);
    return {
        /**
         *
         * @summary Starts the extraction of the data of all unextracted treatment plan requests.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataExtractionPost: function (tenantId, options) {
            return localVarFp.dataExtractionPost(tenantId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes the extraction status of of the treatment plan request so that it will be considered for extraction again.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataExtractionTreatmentPlanRequestsIdDelete: function (id, tenantId, options) {
            return localVarFp.dataExtractionTreatmentPlanRequestsIdDelete(id, tenantId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * DataExtractionApi - object-oriented interface
 * @export
 * @class DataExtractionApi
 * @extends {BaseAPI}
 */
var DataExtractionApi = /** @class */ (function (_super) {
    __extends(DataExtractionApi, _super);
    function DataExtractionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Starts the extraction of the data of all unextracted treatment plan requests.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExtractionApi
     */
    DataExtractionApi.prototype.dataExtractionPost = function (tenantId, options) {
        var _this = this;
        return exports.DataExtractionApiFp(this.configuration).dataExtractionPost(tenantId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes the extraction status of of the treatment plan request so that it will be considered for extraction again.
     * @param {string} id The treatment plan request id.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExtractionApi
     */
    DataExtractionApi.prototype.dataExtractionTreatmentPlanRequestsIdDelete = function (id, tenantId, options) {
        var _this = this;
        return exports.DataExtractionApiFp(this.configuration).dataExtractionTreatmentPlanRequestsIdDelete(id, tenantId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DataExtractionApi;
}(base_1.BaseAPI));
exports.DataExtractionApi = DataExtractionApi;
/**
 * ItemsApi - axios parameter creator
 * @export
 */
exports.ItemsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Download the specified item.
         * @param {string} id The id of an item created during the execution of a workflow.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsIdDownloadGet: function (id, tenantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('itemsIdDownloadGet', 'id', id);
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('itemsIdDownloadGet', 'tenantId', tenantId);
                            localVarPath = "/items/{id}/download"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ItemsApi - functional programming interface
 * @export
 */
exports.ItemsApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ItemsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Download the specified item.
         * @param {string} id The id of an item created during the execution of a workflow.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsIdDownloadGet: function (id, tenantId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.itemsIdDownloadGet(id, tenantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ItemsApi - factory interface
 * @export
 */
exports.ItemsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ItemsApiFp(configuration);
    return {
        /**
         *
         * @summary Download the specified item.
         * @param {string} id The id of an item created during the execution of a workflow.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemsIdDownloadGet: function (id, tenantId, options) {
            return localVarFp.itemsIdDownloadGet(id, tenantId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ItemsApi - object-oriented interface
 * @export
 * @class ItemsApi
 * @extends {BaseAPI}
 */
var ItemsApi = /** @class */ (function (_super) {
    __extends(ItemsApi, _super);
    function ItemsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Download the specified item.
     * @param {string} id The id of an item created during the execution of a workflow.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    ItemsApi.prototype.itemsIdDownloadGet = function (id, tenantId, options) {
        var _this = this;
        return exports.ItemsApiFp(this.configuration).itemsIdDownloadGet(id, tenantId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ItemsApi;
}(base_1.BaseAPI));
exports.ItemsApi = ItemsApi;
/**
 * MonitoringApi - axios parameter creator
 * @export
 */
exports.MonitoringApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Checks the health status of the service and all connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deepHealthGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/deep-health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Checks the health status of the service. Does not include connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns the current version of the service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/version";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * MonitoringApi - functional programming interface
 * @export
 */
exports.MonitoringApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.MonitoringApiAxiosParamCreator(configuration);
    return {
        /**
         * Checks the health status of the service and all connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deepHealthGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deepHealthGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Checks the health status of the service. Does not include connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.healthGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the current version of the service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.versionGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * MonitoringApi - factory interface
 * @export
 */
exports.MonitoringApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.MonitoringApiFp(configuration);
    return {
        /**
         * Checks the health status of the service and all connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deepHealthGet: function (options) {
            return localVarFp.deepHealthGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Checks the health status of the service. Does not include connected services.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthGet: function (options) {
            return localVarFp.healthGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the current version of the service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        versionGet: function (options) {
            return localVarFp.versionGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * MonitoringApi - object-oriented interface
 * @export
 * @class MonitoringApi
 * @extends {BaseAPI}
 */
var MonitoringApi = /** @class */ (function (_super) {
    __extends(MonitoringApi, _super);
    function MonitoringApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Checks the health status of the service and all connected services.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringApi
     */
    MonitoringApi.prototype.deepHealthGet = function (options) {
        var _this = this;
        return exports.MonitoringApiFp(this.configuration).deepHealthGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Checks the health status of the service. Does not include connected services.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringApi
     */
    MonitoringApi.prototype.healthGet = function (options) {
        var _this = this;
        return exports.MonitoringApiFp(this.configuration).healthGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the current version of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringApi
     */
    MonitoringApi.prototype.versionGet = function (options) {
        var _this = this;
        return exports.MonitoringApiFp(this.configuration).versionGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MonitoringApi;
}(base_1.BaseAPI));
exports.MonitoringApi = MonitoringApi;
/**
 * PatientsApi - axios parameter creator
 * @export
 */
exports.PatientsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Perfoms a patient search.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsSearchesPost: function (tenantId, inlineObject, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('patientsSearchesPost', 'tenantId', tenantId);
                            localVarPath = "/patients/searches";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * PatientsApi - functional programming interface
 * @export
 */
exports.PatientsApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.PatientsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Perfoms a patient search.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsSearchesPost: function (tenantId, inlineObject, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patientsSearchesPost(tenantId, inlineObject, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * PatientsApi - factory interface
 * @export
 */
exports.PatientsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.PatientsApiFp(configuration);
    return {
        /**
         *
         * @summary Perfoms a patient search.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsSearchesPost: function (tenantId, inlineObject, options) {
            return localVarFp.patientsSearchesPost(tenantId, inlineObject, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * PatientsApi - object-oriented interface
 * @export
 * @class PatientsApi
 * @extends {BaseAPI}
 */
var PatientsApi = /** @class */ (function (_super) {
    __extends(PatientsApi, _super);
    function PatientsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Perfoms a patient search.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.patientsSearchesPost = function (tenantId, inlineObject, options) {
        var _this = this;
        return exports.PatientsApiFp(this.configuration).patientsSearchesPost(tenantId, inlineObject, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PatientsApi;
}(base_1.BaseAPI));
exports.PatientsApi = PatientsApi;
/**
 * RegionsApi - axios parameter creator
 * @export
 */
exports.RegionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Gets a list of regions available to the current user.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regionsGet: function (tenantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('regionsGet', 'tenantId', tenantId);
                            localVarPath = "/regions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * RegionsApi - functional programming interface
 * @export
 */
exports.RegionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.RegionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Gets a list of regions available to the current user.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regionsGet: function (tenantId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.regionsGet(tenantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * RegionsApi - factory interface
 * @export
 */
exports.RegionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.RegionsApiFp(configuration);
    return {
        /**
         *
         * @summary Gets a list of regions available to the current user.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regionsGet: function (tenantId, options) {
            return localVarFp.regionsGet(tenantId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * RegionsApi - object-oriented interface
 * @export
 * @class RegionsApi
 * @extends {BaseAPI}
 */
var RegionsApi = /** @class */ (function (_super) {
    __extends(RegionsApi, _super);
    function RegionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets a list of regions available to the current user.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionsApi
     */
    RegionsApi.prototype.regionsGet = function (tenantId, options) {
        var _this = this;
        return exports.RegionsApiFp(this.configuration).regionsGet(tenantId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RegionsApi;
}(base_1.BaseAPI));
exports.RegionsApi = RegionsApi;
/**
 * TenantsApi - axios parameter creator
 * @export
 */
exports.TenantsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {boolean} availableToUserOnly Only include tenants which are available to the currently authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsGet: function (availableToUserOnly, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'availableToUserOnly' is not null or undefined
                            common_1.assertParamExists('tenantsGet', 'availableToUserOnly', availableToUserOnly);
                            localVarPath = "/tenants";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (availableToUserOnly !== undefined) {
                                localVarQueryParameter['availableToUserOnly'] = availableToUserOnly;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * TenantsApi - functional programming interface
 * @export
 */
exports.TenantsApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.TenantsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {boolean} availableToUserOnly Only include tenants which are available to the currently authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsGet: function (availableToUserOnly, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tenantsGet(availableToUserOnly, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * TenantsApi - factory interface
 * @export
 */
exports.TenantsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.TenantsApiFp(configuration);
    return {
        /**
         *
         * @param {boolean} availableToUserOnly Only include tenants which are available to the currently authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsGet: function (availableToUserOnly, options) {
            return localVarFp.tenantsGet(availableToUserOnly, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * TenantsApi - object-oriented interface
 * @export
 * @class TenantsApi
 * @extends {BaseAPI}
 */
var TenantsApi = /** @class */ (function (_super) {
    __extends(TenantsApi, _super);
    function TenantsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {boolean} availableToUserOnly Only include tenants which are available to the currently authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    TenantsApi.prototype.tenantsGet = function (availableToUserOnly, options) {
        var _this = this;
        return exports.TenantsApiFp(this.configuration).tenantsGet(availableToUserOnly, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TenantsApi;
}(base_1.BaseAPI));
exports.TenantsApi = TenantsApi;
/**
 * TreatmentPlanRequestsApi - axios parameter creator
 * @export
 */
exports.TreatmentPlanRequestsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Gets a list of SOLID-eligible Treatment Plan Requests with certain filters.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {Array<string>} [requestState] The request states of interest (case-sensitive).
         * @param {boolean} [patientConsentGranted] The patient consent granted status of interest.
         * @param {number} [pageIndex] Index of the page. The first page has index zero.
         * @param {number} [pageSize] Size of the page, that is the number of objects on a page.              For a size smaller than one, all objects are returned.
         * @param {string} [dateTimeFrom] The start of the range where treatment plan requests were created.
         * @param {string} [dateTimeTo] The end of the range where treatment plan requests were created.
         * @param {string} [surgeryDateFrom] The start of the range of when the surgery is happening.
         * @param {string} [surgeryDateTo] The end of the range of when the surgery is happening.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsGet: function (tenantId, requestState, patientConsentGranted, pageIndex, pageSize, dateTimeFrom, dateTimeTo, surgeryDateFrom, surgeryDateTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsGet', 'tenantId', tenantId);
                            localVarPath = "/treatment-plan-requests";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (requestState) {
                                localVarQueryParameter['requestState'] = requestState;
                            }
                            if (patientConsentGranted !== undefined) {
                                localVarQueryParameter['patientConsentGranted'] = patientConsentGranted;
                            }
                            if (pageIndex !== undefined) {
                                localVarQueryParameter['pageIndex'] = pageIndex;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (dateTimeFrom !== undefined) {
                                localVarQueryParameter['dateTimeFrom'] = (dateTimeFrom instanceof Date) ?
                                    dateTimeFrom.toISOString() :
                                    dateTimeFrom;
                            }
                            if (dateTimeTo !== undefined) {
                                localVarQueryParameter['dateTimeTo'] = (dateTimeTo instanceof Date) ?
                                    dateTimeTo.toISOString() :
                                    dateTimeTo;
                            }
                            if (surgeryDateFrom !== undefined) {
                                localVarQueryParameter['surgeryDateFrom'] = (surgeryDateFrom instanceof Date) ?
                                    surgeryDateFrom.toISOString() :
                                    surgeryDateFrom;
                            }
                            if (surgeryDateTo !== undefined) {
                                localVarQueryParameter['surgeryDateTo'] = (surgeryDateTo instanceof Date) ?
                                    surgeryDateTo.toISOString() :
                                    surgeryDateTo;
                            }
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets a Treatment Plan Request using ID.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdGet: function (id, tenantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdGet', 'id', id);
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdGet', 'tenantId', tenantId);
                            localVarPath = "/treatment-plan-requests/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets whether the patient\'s consent has been granted for a treatment plan request.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPatientConsentsGet: function (id, tenantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdPatientConsentsGet', 'id', id);
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdPatientConsentsGet', 'tenantId', tenantId);
                            localVarPath = "/treatment-plan-requests/{id}/patient-consents"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPostOperativeDataGet: function (id, tenantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdPostOperativeDataGet', 'id', id);
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdPostOperativeDataGet', 'tenantId', tenantId);
                            localVarPath = "/treatment-plan-requests/{id}/post-operative-data"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {PostOperativeData} [postOperativeData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPostOperativeDataPut: function (id, tenantId, postOperativeData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdPostOperativeDataPut', 'id', id);
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdPostOperativeDataPut', 'tenantId', tenantId);
                            localVarPath = "/treatment-plan-requests/{id}/post-operative-data"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(postOperativeData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPreOperativeDataGet: function (id, tenantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdPreOperativeDataGet', 'id', id);
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdPreOperativeDataGet', 'tenantId', tenantId);
                            localVarPath = "/treatment-plan-requests/{id}/pre-operative-data"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {PreOperativeData} [preOperativeData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPreOperativeDataPut: function (id, tenantId, preOperativeData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdPreOperativeDataPut', 'id', id);
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsIdPreOperativeDataPut', 'tenantId', tenantId);
                            localVarPath = "/treatment-plan-requests/{id}/pre-operative-data"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(preOperativeData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Grants or removes patient consent to process the treatment plan request\'s data.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {Array<object>} [requestBody] Whether a patient\&#39;s consent has been granted to process their data in SOLID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsPatientConsentsPut: function (tenantId, requestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('treatmentPlanRequestsPatientConsentsPut', 'tenantId', tenantId);
                            localVarPath = "/treatment-plan-requests/patient-consents";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * TreatmentPlanRequestsApi - functional programming interface
 * @export
 */
exports.TreatmentPlanRequestsApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.TreatmentPlanRequestsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Gets a list of SOLID-eligible Treatment Plan Requests with certain filters.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {Array<string>} [requestState] The request states of interest (case-sensitive).
         * @param {boolean} [patientConsentGranted] The patient consent granted status of interest.
         * @param {number} [pageIndex] Index of the page. The first page has index zero.
         * @param {number} [pageSize] Size of the page, that is the number of objects on a page.              For a size smaller than one, all objects are returned.
         * @param {string} [dateTimeFrom] The start of the range where treatment plan requests were created.
         * @param {string} [dateTimeTo] The end of the range where treatment plan requests were created.
         * @param {string} [surgeryDateFrom] The start of the range of when the surgery is happening.
         * @param {string} [surgeryDateTo] The end of the range of when the surgery is happening.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsGet: function (tenantId, requestState, patientConsentGranted, pageIndex, pageSize, dateTimeFrom, dateTimeTo, surgeryDateFrom, surgeryDateTo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.treatmentPlanRequestsGet(tenantId, requestState, patientConsentGranted, pageIndex, pageSize, dateTimeFrom, dateTimeTo, surgeryDateFrom, surgeryDateTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets a Treatment Plan Request using ID.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdGet: function (id, tenantId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.treatmentPlanRequestsIdGet(id, tenantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets whether the patient\'s consent has been granted for a treatment plan request.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPatientConsentsGet: function (id, tenantId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.treatmentPlanRequestsIdPatientConsentsGet(id, tenantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPostOperativeDataGet: function (id, tenantId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.treatmentPlanRequestsIdPostOperativeDataGet(id, tenantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {PostOperativeData} [postOperativeData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPostOperativeDataPut: function (id, tenantId, postOperativeData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.treatmentPlanRequestsIdPostOperativeDataPut(id, tenantId, postOperativeData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPreOperativeDataGet: function (id, tenantId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.treatmentPlanRequestsIdPreOperativeDataGet(id, tenantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {PreOperativeData} [preOperativeData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPreOperativeDataPut: function (id, tenantId, preOperativeData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.treatmentPlanRequestsIdPreOperativeDataPut(id, tenantId, preOperativeData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Grants or removes patient consent to process the treatment plan request\'s data.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {Array<object>} [requestBody] Whether a patient\&#39;s consent has been granted to process their data in SOLID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsPatientConsentsPut: function (tenantId, requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.treatmentPlanRequestsPatientConsentsPut(tenantId, requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * TreatmentPlanRequestsApi - factory interface
 * @export
 */
exports.TreatmentPlanRequestsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.TreatmentPlanRequestsApiFp(configuration);
    return {
        /**
         *
         * @summary Gets a list of SOLID-eligible Treatment Plan Requests with certain filters.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {Array<string>} [requestState] The request states of interest (case-sensitive).
         * @param {boolean} [patientConsentGranted] The patient consent granted status of interest.
         * @param {number} [pageIndex] Index of the page. The first page has index zero.
         * @param {number} [pageSize] Size of the page, that is the number of objects on a page.              For a size smaller than one, all objects are returned.
         * @param {string} [dateTimeFrom] The start of the range where treatment plan requests were created.
         * @param {string} [dateTimeTo] The end of the range where treatment plan requests were created.
         * @param {string} [surgeryDateFrom] The start of the range of when the surgery is happening.
         * @param {string} [surgeryDateTo] The end of the range of when the surgery is happening.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsGet: function (tenantId, requestState, patientConsentGranted, pageIndex, pageSize, dateTimeFrom, dateTimeTo, surgeryDateFrom, surgeryDateTo, options) {
            return localVarFp.treatmentPlanRequestsGet(tenantId, requestState, patientConsentGranted, pageIndex, pageSize, dateTimeFrom, dateTimeTo, surgeryDateFrom, surgeryDateTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets a Treatment Plan Request using ID.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdGet: function (id, tenantId, options) {
            return localVarFp.treatmentPlanRequestsIdGet(id, tenantId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets whether the patient\'s consent has been granted for a treatment plan request.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPatientConsentsGet: function (id, tenantId, options) {
            return localVarFp.treatmentPlanRequestsIdPatientConsentsGet(id, tenantId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPostOperativeDataGet: function (id, tenantId, options) {
            return localVarFp.treatmentPlanRequestsIdPostOperativeDataGet(id, tenantId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {PostOperativeData} [postOperativeData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPostOperativeDataPut: function (id, tenantId, postOperativeData, options) {
            return localVarFp.treatmentPlanRequestsIdPostOperativeDataPut(id, tenantId, postOperativeData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPreOperativeDataGet: function (id, tenantId, options) {
            return localVarFp.treatmentPlanRequestsIdPreOperativeDataGet(id, tenantId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {PreOperativeData} [preOperativeData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsIdPreOperativeDataPut: function (id, tenantId, preOperativeData, options) {
            return localVarFp.treatmentPlanRequestsIdPreOperativeDataPut(id, tenantId, preOperativeData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Grants or removes patient consent to process the treatment plan request\'s data.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {Array<object>} [requestBody] Whether a patient\&#39;s consent has been granted to process their data in SOLID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        treatmentPlanRequestsPatientConsentsPut: function (tenantId, requestBody, options) {
            return localVarFp.treatmentPlanRequestsPatientConsentsPut(tenantId, requestBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * TreatmentPlanRequestsApi - object-oriented interface
 * @export
 * @class TreatmentPlanRequestsApi
 * @extends {BaseAPI}
 */
var TreatmentPlanRequestsApi = /** @class */ (function (_super) {
    __extends(TreatmentPlanRequestsApi, _super);
    function TreatmentPlanRequestsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets a list of SOLID-eligible Treatment Plan Requests with certain filters.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {Array<string>} [requestState] The request states of interest (case-sensitive).
     * @param {boolean} [patientConsentGranted] The patient consent granted status of interest.
     * @param {number} [pageIndex] Index of the page. The first page has index zero.
     * @param {number} [pageSize] Size of the page, that is the number of objects on a page.              For a size smaller than one, all objects are returned.
     * @param {string} [dateTimeFrom] The start of the range where treatment plan requests were created.
     * @param {string} [dateTimeTo] The end of the range where treatment plan requests were created.
     * @param {string} [surgeryDateFrom] The start of the range of when the surgery is happening.
     * @param {string} [surgeryDateTo] The end of the range of when the surgery is happening.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanRequestsApi
     */
    TreatmentPlanRequestsApi.prototype.treatmentPlanRequestsGet = function (tenantId, requestState, patientConsentGranted, pageIndex, pageSize, dateTimeFrom, dateTimeTo, surgeryDateFrom, surgeryDateTo, options) {
        var _this = this;
        return exports.TreatmentPlanRequestsApiFp(this.configuration).treatmentPlanRequestsGet(tenantId, requestState, patientConsentGranted, pageIndex, pageSize, dateTimeFrom, dateTimeTo, surgeryDateFrom, surgeryDateTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets a Treatment Plan Request using ID.
     * @param {string} id The treatment plan request id.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanRequestsApi
     */
    TreatmentPlanRequestsApi.prototype.treatmentPlanRequestsIdGet = function (id, tenantId, options) {
        var _this = this;
        return exports.TreatmentPlanRequestsApiFp(this.configuration).treatmentPlanRequestsIdGet(id, tenantId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets whether the patient\'s consent has been granted for a treatment plan request.
     * @param {string} id The treatment plan request id.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanRequestsApi
     */
    TreatmentPlanRequestsApi.prototype.treatmentPlanRequestsIdPatientConsentsGet = function (id, tenantId, options) {
        var _this = this;
        return exports.TreatmentPlanRequestsApiFp(this.configuration).treatmentPlanRequestsIdPatientConsentsGet(id, tenantId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id The treatment plan request id.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanRequestsApi
     */
    TreatmentPlanRequestsApi.prototype.treatmentPlanRequestsIdPostOperativeDataGet = function (id, tenantId, options) {
        var _this = this;
        return exports.TreatmentPlanRequestsApiFp(this.configuration).treatmentPlanRequestsIdPostOperativeDataGet(id, tenantId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id The treatment plan request id.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {PostOperativeData} [postOperativeData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanRequestsApi
     */
    TreatmentPlanRequestsApi.prototype.treatmentPlanRequestsIdPostOperativeDataPut = function (id, tenantId, postOperativeData, options) {
        var _this = this;
        return exports.TreatmentPlanRequestsApiFp(this.configuration).treatmentPlanRequestsIdPostOperativeDataPut(id, tenantId, postOperativeData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id The treatment plan request id.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanRequestsApi
     */
    TreatmentPlanRequestsApi.prototype.treatmentPlanRequestsIdPreOperativeDataGet = function (id, tenantId, options) {
        var _this = this;
        return exports.TreatmentPlanRequestsApiFp(this.configuration).treatmentPlanRequestsIdPreOperativeDataGet(id, tenantId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id The treatment plan request id.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {PreOperativeData} [preOperativeData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanRequestsApi
     */
    TreatmentPlanRequestsApi.prototype.treatmentPlanRequestsIdPreOperativeDataPut = function (id, tenantId, preOperativeData, options) {
        var _this = this;
        return exports.TreatmentPlanRequestsApiFp(this.configuration).treatmentPlanRequestsIdPreOperativeDataPut(id, tenantId, preOperativeData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Grants or removes patient consent to process the treatment plan request\'s data.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {Array<object>} [requestBody] Whether a patient\&#39;s consent has been granted to process their data in SOLID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanRequestsApi
     */
    TreatmentPlanRequestsApi.prototype.treatmentPlanRequestsPatientConsentsPut = function (tenantId, requestBody, options) {
        var _this = this;
        return exports.TreatmentPlanRequestsApiFp(this.configuration).treatmentPlanRequestsPatientConsentsPut(tenantId, requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TreatmentPlanRequestsApi;
}(base_1.BaseAPI));
exports.TreatmentPlanRequestsApi = TreatmentPlanRequestsApi;
/**
 * WorkflowsApi - axios parameter creator
 * @export
 */
exports.WorkflowsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Starts the workflow for a treatment plan request.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsTreatmentPlanRequestsIdPost: function (id, tenantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('workflowsTreatmentPlanRequestsIdPost', 'id', id);
                            // verify required parameter 'tenantId' is not null or undefined
                            common_1.assertParamExists('workflowsTreatmentPlanRequestsIdPost', 'tenantId', tenantId);
                            localVarPath = "/workflows/treatment-plan-requests/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tenantId !== undefined && tenantId !== null) {
                                localVarHeaderParameter['tenant_id'] = String(tenantId);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * WorkflowsApi - functional programming interface
 * @export
 */
exports.WorkflowsApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.WorkflowsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Starts the workflow for a treatment plan request.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsTreatmentPlanRequestsIdPost: function (id, tenantId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowsTreatmentPlanRequestsIdPost(id, tenantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * WorkflowsApi - factory interface
 * @export
 */
exports.WorkflowsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.WorkflowsApiFp(configuration);
    return {
        /**
         *
         * @summary Starts the workflow for a treatment plan request.
         * @param {string} id The treatment plan request id.
         * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsTreatmentPlanRequestsIdPost: function (id, tenantId, options) {
            return localVarFp.workflowsTreatmentPlanRequestsIdPost(id, tenantId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * WorkflowsApi - object-oriented interface
 * @export
 * @class WorkflowsApi
 * @extends {BaseAPI}
 */
var WorkflowsApi = /** @class */ (function (_super) {
    __extends(WorkflowsApi, _super);
    function WorkflowsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Starts the workflow for a treatment plan request.
     * @param {string} id The treatment plan request id.
     * @param {string} tenantId The id of the SOLID tenant. Please refer to the &#x60;/tenants&#x60; endpoint for a list of available tenants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    WorkflowsApi.prototype.workflowsTreatmentPlanRequestsIdPost = function (id, tenantId, options) {
        var _this = this;
        return exports.WorkflowsApiFp(this.configuration).workflowsTreatmentPlanRequestsIdPost(id, tenantId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WorkflowsApi;
}(base_1.BaseAPI));
exports.WorkflowsApi = WorkflowsApi;
